import { FC } from 'react';

interface FilterLinesIconProps {
  width?: string;
  height?: string;
  color?: string;
}

export const FilterLinesIcon: FC<FilterLinesIconProps> = ({ width = '12', height = '7', color = '#BBBEC0' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 7" fill="none">
      <path
        d="M10.6875 1.125H0.5625C0.413316 1.125 0.270242 1.06574 0.164752 0.960248C0.0592632 0.854758 0 0.711684 0 0.5625C0 0.413316 0.0592632 0.270242 0.164752 0.164752C0.270242 0.0592632 0.413316 0 0.5625 0H10.6875C10.8367 0 10.9798 0.0592632 11.0852 0.164752C11.1907 0.270242 11.25 0.413316 11.25 0.5625C11.25 0.711684 11.1907 0.854758 11.0852 0.960248C10.9798 1.06574 10.8367 1.125 10.6875 1.125ZM8.8125 3.75H2.4375C2.28832 3.75 2.14524 3.69074 2.03975 3.58525C1.93426 3.47976 1.875 3.33668 1.875 3.1875C1.875 3.03832 1.93426 2.89524 2.03975 2.78975C2.14524 2.68426 2.28832 2.625 2.4375 2.625H8.8125C8.96168 2.625 9.10476 2.68426 9.21025 2.78975C9.31574 2.89524 9.375 3.03832 9.375 3.1875C9.375 3.33668 9.31574 3.47976 9.21025 3.58525C9.10476 3.69074 8.96168 3.75 8.8125 3.75ZM6.5625 6.375H4.6875C4.53832 6.375 4.39524 6.31574 4.28975 6.21025C4.18426 6.10476 4.125 5.96168 4.125 5.8125C4.125 5.66332 4.18426 5.52024 4.28975 5.41475C4.39524 5.30926 4.53832 5.25 4.6875 5.25H6.5625C6.71168 5.25 6.85476 5.30926 6.96025 5.41475C7.06574 5.52024 7.125 5.66332 7.125 5.8125C7.125 5.96168 7.06574 6.10476 6.96025 6.21025C6.85476 6.31574 6.71168 6.375 6.5625 6.375Z"
        fill={color}
      />
    </svg>
  );
};
